import { render, staticRenderFns } from "./NotificationTopBar.vue?vue&type=template&id=603d0a1e"
import script from "./NotificationTopBar.vue?vue&type=script&lang=js"
export * from "./NotificationTopBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports